export default "__VITE_PUBLIC_ASSET__d652af0f__"